import { Employee, ProjectModel, ProjectAddress, ProjectAddress_DB } from "@models/Models";
import { Models } from "appwrite";

export const toEmployee = (doc: Models.DefaultRow): Employee => ({
    email: doc.email,
    firstName: doc.firstName,
    lastName: doc.lastName,
    phone: doc.phone,
    status: doc.status,
    createdAt: doc.$createdAt,
    id: doc.$id,
});

export const toAddress = (doc: Models.DefaultRow): ProjectAddress => ({
    city: doc.city,
    country: doc.country,
    hausnummer: doc.hausnummer,
    stiege: doc.stiege,
    street: doc.street,
    zipCode: doc.zipCode,
    id: doc.$id,
});

export const toProject = (doc: Models.DefaultRow): ProjectModel => ({
    id: doc.$id,
    createdAt: doc.$createdAt,
    addresses: doc.addresses.map((adrs: Models.DefaultRow) => toAddress(adrs)),
    datenschutzText: doc.datenschutzText,
    employeeTeam: doc.employeeTeam,
    infoText: doc.infoText,
    logoClient: doc.logoClient,
    maxTime: doc.maxTime,
    name: doc.name,
    projectLogo: doc.projectLogo,
    sms1Text: doc.sms1Text,
    sms2Text: doc.sms2Text,
    status: doc.status,
    warningAfter: doc.warningAfter,
});